<template>
  <section class="clients">
    <h1>Voor wie doen wij dat</h1>
    <div class="achmea"></div>
    <div class="actemium"></div>
    <div class="amersfoort"></div>
    <div class="amsterdam"></div>
    <!--     <div class="ans"></div>
 -->
    <div class="ballastnedam"></div>
    <div class="bam"></div>
    <div class="barneveld"></div>
    <!--     <div class="bcg"></div>
 -->
    <div class="bol"></div>
    <div class="buch"></div>
    <div class="boskalis"></div>
    <div class="cbre"></div>
    <div class="connexxion"></div>
    <div class="coolblue"></div>
    <div class="de-alliantie"></div>

    <div class="duravermeer"></div>

    <div class="eindhoven"></div>
    <div class="engie"></div>
    <div class="evofenedex"></div>
    <div class="firda"></div>

    <div class="gemeente-utrecht"></div>
    <div class="ggd-drenthe"></div>

    <div class="heijmans"></div>

    <div class="honeywell"></div>
    <div class="hu"></div>
    <div class="jhm"></div>
    <div class="leeuwarden"></div>

    <div class="mac-donalds"></div>
    <div class="merck"></div>

    <div class="nen"></div>

    <div class="philips"></div>
    <div class="plegt-vos"></div>
    <div class="prorail"></div>
    <div class="provincie-utrecht"></div>
    <div class="rijkswaterstaat"></div>
    <div class="rode-kruis"></div>
    <div class="siemens"></div>
    <div class="spie"></div>
    <div class="strukton"></div>
    <div class="tauw"></div>
    <div class="trebbe"></div>
    <div class="tu-delft"></div>
    <div class="ulc"></div>
    <div class="umcg"></div>
    <div class="unica"></div>
    <div class="volker-wessels"></div>
    <div class="vorm"></div>
    <div class="vrf"></div>
    <div class="zoetermeer"></div>
    <div class="zueblin"></div>
    <h3 class="footer-text">
      ... en 4000 andere organisaties en professionals.
    </h3>
  </section>
</template>

<script>
export default {}
</script>

<style lang="scss" scoped>
.clients {
  h1 {
    margin-bottom: 40px;
    width: 100%;
    text-align: center;
  }
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  div {
    /*  width: 90px;
    height: 45px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center center;
    margin: 20px 40px;
    flex-shrink: 0; */
    width: 33.3%;
    height: 25px;
    background-repeat: no-repeat;
    background-position: center center;
    /* margin: 20px 0px; */
    flex-shrink: 0;
    background-origin: content-box;
    padding: 0 20px 0;
    background-size: contain;
    margin-bottom: 50px;

    @media only screen and (min-width: 480px) {
      width: 25%;
    }

    @media only screen and (min-width: 768px) {
      width: 16%;
    }

    @media only screen and (min-width: 1280px) {
      width: 10%;
    }
  }
}

.footer-text {
  width: 100%;
  text-align: center;
}

.achmea {
  background-image: url('@/images/clients/achmea.png');
}
.amsterdam {
  background-image: url('@/images/clients/amsterdam.png');
}

.ans {
  background-image: url('@/images/clients/ans-logo.png');
}
.ballastnedam {
  background-image: url('@/images/clients/ballastnedam.png');
}

.bam {
  background-image: url('@/images/clients/bam.png');
}
/* 
.bcg {
  background-image: url('@/images/clients/achmea.png');
}
 */
.bol {
  background-image: url('@/images/clients/bol.png');
}

.boskalis {
  background-image: url('@/images/clients/boskalis.png');
}

.connexxion {
  background-image: url('@/images/clients/connexxion.png');
}

.coolblue {
  background-image: url('@/images/clients/coolblue.png');
}

.de-alliantie {
  background-image: url('@/images/clients/de-alliantie.png');
}

.den-haag {
  background-image: url('@/images/clients/den-haag.png');
}
.duravermeer {
  background-image: url('@/images/clients/duravermeer.png');
}

.eerste-kamer {
  background-image: url('@/images/clients/eerste-kamer.png');
}
.engie {
  background-image: url('@/images/clients/engie.png');
}
.evofenedex {
  background-image: url('@/images/clients/evofenedex.jpg');
}
.friesland-college {
  background-image: url('@/images/clients/friesland-college.png');
}
.ggd-drenthe {
  background-image: url('@/images/clients/ggd-drenthe.jpg');
}
.gemeente-utrecht {
  background-image: url('@/images/clients/gemeente-utrecht.png');
}

.heijmans {
  background-image: url('@/images/clients/heijmans.png');
}
.het-concert-gebouw {
  background-image: url('@/images/clients/het-concert-gebouw.png');
}
.honeywell {
  background-image: url('@/images/clients/honeywell.png');
}
.hu {
  background-image: url('@/images/clients/hu.png');
}
.jhm {
  background-image: url('@/images/clients/jhm.png');
}

.mac-donalds {
  background-image: url('@/images/clients/mac-donalds.png');
}
.mammoet {
  background-image: url('@/images/clients/mammoet.png');
}
.mediahuis {
  background-image: url('@/images/clients/media-huis.jpg');
}

.nen {
  background-image: url('@/images/clients/nen.png');
}
.ns {
  background-image: url('@/images/clients/ns.png');
}
.philips {
  background-image: url('@/images/clients/philips.png');
}
.plegt-vos {
  background-image: url('@/images/clients/plegt-vos.jpg');
}
.postnl {
  background-image: url('@/images/clients/postnl.png');
}
.prorail {
  background-image: url('@/images/clients/prorail.png');
}
.provincie-utrecht {
  background-image: url('@/images/clients/provincie-utrecht.png');
}
.provincie-friesland {
  background-image: url('@/images/clients/provincie-friesland.png');
}
.rijks-museum {
  background-image: url('@/images/clients/rijks-museum.png');
}
.rijkswaterstaat {
  background-image: url('@/images/clients/rijkswaterstaat.png');
}
.rode-kruis {
  background-image: url('@/images/clients/rode-kruis.png');
}

.siemens {
  background-image: url('@/images/clients/siemens.png');
}
.spie {
  background-image: url('@/images/clients/spie.png');
}
.strukton {
  background-image: url('@/images/clients/strukton.png');
}
.tauw {
  background-image: url('@/images/clients/tauw.png');
}
.trebbe {
  background-image: url('@/images/clients/trebbe.jpg');
}
.tu-delft {
  background-image: url('@/images/clients/tu-delft.png');
}
.ulc {
  background-image: url('@/images/clients/ulc.jpg');
}
.umcg {
  background-image: url('@/images/clients/umcg.png');
}
.unica {
  background-image: url('@/images/clients/unica.png');
}
.volker-wessels {
  background-image: url('@/images/clients/volker-wessels.png');
}
.vorm {
  background-image: url('@/images/clients/vorm.jpg');
}
.vrf {
  background-image: url('@/images/clients/vrf.jpg');
}

.amersfoort {
  background-image: url('@/images/clients/amersfoort.svg');
}
.barneveld {
  background-image: url('@/images/clients/gemeente-barneveld.svg');
}
.actemium {
  background-image: url('@/images/clients/logo-actemium.svg');
}

.cbre {
  background-image: url('@/images/clients/logo-cbre.svg');
}

.buch {
  background-image: url('@/images/clients/logo-de-buch.svg');
}

.eindhoven {
  background-image: url('@/images/clients/logo-eindhoven.svg');
}

.firda {
  background-image: url('@/images/clients/logo-firda.svg');
}
.leeuwarden {
  background-image: url('@/images/clients/logo-gemeente-leeuwarden.svg');
}

.zoetermeer {
  background-image: url('@/images/clients/logo-gemeente-zoetermeer.png');
}
.merck {
  background-image: url('@/images/clients/logo-merck.svg');
}
.zueblin {
  background-image: url('../../images/clients/zueblin.png');
}
</style>
